<dialog
  #dialog
  qai-dialog
  [description]="''"
  [heading]="''"
  (afterClose)="handleClose()"
>
  <div class="icon">
    <qai-icon [kind]="'upload'" [size]="'24px'"></qai-icon>
  </div>
  <div class="title">Publish simulation</div>
  <div class="content">
    {{ description }}
  </div>

  <div class="modal-actions">
    <button qai-button kind="secondary" [size]="'medium'" (click)="hideModal()">
      Continue editing
    </button>
    <button
      qai-button
      kind="primary"
      [size]="'medium'"
      [disabled]="networkRequestInProgress"
      (click)="handleConfirm()"
    >
      Publish
    </button>
  </div>
</dialog>
